'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSimpleAnimate = require('react-simple-animate');

var _reactSimpleAnimate2 = _interopRequireDefault(_reactSimpleAnimate);

var _validImgSrc = require('./utils/validImgSrc');

var _validImgSrc2 = _interopRequireDefault(_validImgSrc);

var _simpleImgProvider = require('./simpleImgProvider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var commonStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%'
};
var rootStyle = {
  position: 'relative',
  overflow: 'hidden',
  display: 'flex'
};
var defaultDisappearStyle = { opacity: 0 };
var defaultDisappearInSecond = 0.3;
var defaultImgPlaceholder = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
var defaultPlaceholderColor = 'white';
var onCompleteStyle = { display: 'none' };
var fullWidthStyle = { width: '100%' };
var hiddenStyle = { visibility: 'hidden' };

var SimpleImg = function (_React$PureComponent) {
  _inherits(SimpleImg, _React$PureComponent);

  function SimpleImg(props, context) {
    _classCallCheck(this, SimpleImg);

    var _this = _possibleConstructorReturn(this, (SimpleImg.__proto__ || Object.getPrototypeOf(SimpleImg)).call(this, props));

    _this.state = {
      loaded: false,
      isDocumentLoad: false
    };
    _this.element = null;


    _this.state = {
      loaded: false,
      useContext: !!context[_simpleImgProvider.IMAGES_LOADED],
      isDocumentLoad: false
    };
    return _this;
  }

  _createClass(SimpleImg, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.element) return;

      if (this.state.useContext && this.state.isDocumentLoad) {
        this.context[_simpleImgProvider.APPEND_IMAGE_REF](this.element);
      } else {
        /* eslint-disable */
        window.addEventListener('load', function () {
          _this2.setState({
            isDocumentLoad: true
          });
        });
        if ((this.state.isDocumentLoad || document.readyState === 'complete') && window.__REACT_SIMPLE_IMG__) {
          window.__REACT_SIMPLE_IMG__.observer.observe(this.element);
        }
        /* eslint-enable */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (!this.element || this.state.loaded) return;

      if (this.state.useContext && nextContext[_simpleImgProvider.IMAGES_LOADED].has(this.element)) {
        this.setState({
          loaded: true
        });

        if (this.element) nextContext[_simpleImgProvider.REMOVE_IMAGE_REF](this.element);
      }

      if (nextContext[_simpleImgProvider.DOCUMENT_LOADED]) {
        this.setState({
          isDocumentLoad: true
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.isDocumentLoad) {
        if (this.state.useContext) {
          this.context[_simpleImgProvider.APPEND_IMAGE_REF](this.element);
        } else {
          /* eslint-disable */
          if (this.element !== null) window.__REACT_SIMPLE_IMG__.observer.observe(this.element);
          /* eslint-enable */
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.element) return;

      if (this.state.useContext) {
        this.context[_simpleImgProvider.REMOVE_IMAGE_REF](this.element);
      } else {
        /* eslint-disable */
        if (!window.__REACT_SIMPLE_IMG__) return;

        var _window$__REACT_SIMPL = window.__REACT_SIMPLE_IMG__,
            observer = _window$__REACT_SIMPL.observer,
            imgLoadingRefs = _window$__REACT_SIMPL.imgLoadingRefs;
        /* eslint-enable */

        observer.unobserve(this.element);

        if (imgLoadingRefs.has(this.element)) {
          imgLoadingRefs.get(this.element).src = '';
          imgLoadingRefs.delete(this.element);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          src = _props.src,
          className = _props.imgClassName,
          wrapperClassName = _props.wrapperClassName,
          width = _props.width,
          height = _props.height,
          alt = _props.alt,
          srcSet = _props.srcSet,
          sizes = _props.sizes,
          _props$animationDurat = _props.animationDuration,
          animationDuration = _props$animationDurat === undefined ? defaultDisappearInSecond : _props$animationDurat,
          _props$animationEndSt = _props.animationEndStyle,
          animationEndStyle = _props$animationEndSt === undefined ? defaultDisappearStyle : _props$animationEndSt,
          _props$placeholder = _props.placeholder,
          placeholder = _props$placeholder === undefined ? defaultPlaceholderColor : _props$placeholder;
      var loaded = this.state.loaded;

      var isValidImgSrc = (0, _validImgSrc2.default)(placeholder);
      var inlineStyle = _extends({}, commonStyle, !isValidImgSrc ? { background: placeholder } : null);
      var imgPlaceholder = isValidImgSrc ? placeholder : defaultImgPlaceholder;
      var isSrcSetFulfilled = this.element && this.element.src !== imgPlaceholder;

      return _react2.default.createElement(
        'span',
        { style: rootStyle, className: wrapperClassName },
        _react2.default.createElement('img', _extends({ width: width, height: height, sizes: sizes, className: className }, {
          alt: alt,
          ref: function ref(element) {
            _this3.element = element;
          },
          src: loaded ? src : imgPlaceholder,
          srcSet: loaded ? srcSet : '',
          'data-src': src,
          'data-srcset': srcSet,
          style: _extends({}, !isValidImgSrc && !loaded && !isSrcSetFulfilled ? hiddenStyle : null)
        })),
        _react2.default.createElement(
          _reactSimpleAnimate2.default,
          _extends({
            startAnimation: loaded,
            durationSeconds: animationDuration,
            endStyle: _extends({}, inlineStyle, animationEndStyle, !isValidImgSrc ? fullWidthStyle : null),
            onCompleteStyle: onCompleteStyle
          }, !isValidImgSrc ? {
            startStyle: _extends({}, inlineStyle, fullWidthStyle)
          } : null),
          isValidImgSrc && _react2.default.createElement('img', _extends({ width: width, height: height, className: className }, { style: inlineStyle, alt: alt, src: placeholder }))
        )
      );
    }
  }]);

  return SimpleImg;
}(_react2.default.PureComponent);

SimpleImg.contextTypes = _simpleImgProvider.contextTypes;
exports.default = SimpleImg;